var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.getparentproperty) +
          _vm._s(_vm.getConfirmBoxResponse) +
          "\n  "
      ),
      _c("div", [
        _c("li", { staticClass: "card" }, [
          _vm.certificateflag
            ? _c(
                "a",
                {
                  staticClass: "menu-title hover-effect white",
                  class: {
                    active:
                      _vm.$router.currentRoute.path === "formtemplateehrlite",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.gotoURL("/formtemplateehrlite")
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass:
                      "certificate toggle-menu toggle-menu-2 tooltip-text",
                    attrs: {
                      title: _vm.$t("Certificates"),
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                    },
                  }),
                  _vm._v(_vm._s(_vm.$t("Certificates")) + "\n      "),
                ]
              )
            : _vm._e(),
        ]),
        _vm._m(0),
        this.thisparentproperty.saveddatetimestr
          ? _c("li", { staticClass: "card" }, [
              _c(
                "a",
                {
                  staticClass: "menu-title hover-effect global-disabled",
                  staticStyle: { color: "#fff !important", opacity: "1" },
                },
                [
                  _c("span", {
                    staticClass:
                      "savebtn toggle-menu toggle-menu-2 tooltip-text",
                    attrs: {
                      title: _vm.thisparentproperty.saveddatetimestr
                        ? this.$t("Lastsavedat") +
                          this.thisparentproperty.saveddatetimestr
                        : "",
                      "data-toggle": "tooltip",
                      "data-placement": "right",
                    },
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("Lastsavedat")) +
                      " " +
                      _vm._s(+" " + this.thisparentproperty.saveddatetimestr) +
                      "\n      "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _c("createTemplatePopup", {
        attrs: {
          popuptitle: _vm.templatepopuptitle,
          showmodal: _vm.openshowtemplate,
        },
        on: {
          cancelAction: function ($event) {
            _vm.openshowtemplate = false
            _vm.templatepopuptitle = ""
          },
        },
      }),
      _c("ConfirmBox", {
        ref: "confirmcomp",
        attrs: { showmodal: _vm.showCnfrmPopUp, actionmessage: _vm.actionMsg },
        on: {
          cancelAction: function ($event) {
            _vm.showCnfrmPopUp = false
            _vm.confrmPopUpResponse = false
          },
          confirmAction: function ($event) {
            _vm.showCnfrmPopUp = false
            _vm.confrmPopUpResponse = true
          },
        },
      }),
      _c("Messages", {
        attrs: {
          iserror: _vm.iserrormsg,
          datamessage: _vm.sucessmsgtext,
          isVisible: _vm.isdisplaymsg,
        },
        on: { closemsg: _vm.closeMessage },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "px-4" }, [
      _c("div", { staticClass: "btnhold p-0" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }